export interface TableController {
  reload: () => void
  getSeleted: () => any[]
  setLoading?: (loading: boolean) => void
}


export function useTableController() {
  
  return {
    reload: async () => { },
    getSeleted: () => { return [] },
    setLoading: (loading: boolean) => { },
  }
}